<template>
  <WsMain>
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :liveSearching="true"
      :sortBy="sortBy"
      :showFields="showFields"
      orderBy="sequence"
      orderWay="asc"
    ></WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/tag";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: ["sequence", "name", "updated_at", "updated_admin"],
    liveSearching: true,
    sortBy: "sequence",
  }),
};
</script>